import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ message }) => {
  return (
    <div className="loading-indicator-floating">
      <div className="spinner-container">
        <div className="modern-spinner"></div>
      </div>
      <div className="text-section">
        <p className="loading-text">{message || '変換中...'}</p>
        <p className="loading-subtext">少々お待ちください</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;